<div class="esn-toast" [class.esn-toast--danger]="tone() === 'danger'">
  <div class="esn-toast__body">
    <esn-icon class="esn-toast__icon" name="info" [size]="24" />
    <p class="esn-toast__message">{{ message() }}</p>
  </div>
  @if (actionLabel(); as label) {
    <esn-button variant="danger-outline" [fullWidth]="true" (clicked)="action.emit()">{{ label }}</esn-button>
  }
</div>
